import { UseMutationOptions, UseQueryOptions } from "@tanstack/react-query";
import createFetchClient, {
  FetchResponse,
  MaybeOptionalInit,
} from "openapi-fetch";
import createClient, { QueryKey } from "openapi-react-query";
import type {
  HttpMethod,
  MediaType,
  PathsWithMethod,
} from "openapi-typescript-helpers";

import { BASE_PATH } from "@/utils/constants/api";

import type { paths } from "./v1";

const fetchClient = createFetchClient<paths>({
    baseUrl: BASE_PATH,
  }),
  $api = createClient(fetchClient);
type Paths = paths;
type Media = MediaType;
type ApiMutateShape<
  Method extends HttpMethod,
  Path extends PathsWithMethod<Paths, Method>,
  Init extends MaybeOptionalInit<Paths[Path], Method> = MaybeOptionalInit<
    Paths[Path],
    Method
  >,
  Response extends Required<
    FetchResponse<
      Paths[Path][Method] & Record<string, Record<HttpMethod, object>>,
      Init,
      Media
    >
  > = Required<
    FetchResponse<
      Paths[Path][Method] & Record<string, Record<HttpMethod, object>>,
      Init,
      Media
    >
  >,
  Options extends Omit<
    UseMutationOptions<Response["data"], Response["error"], Init>,
    "mutationKey" | "mutationFn"
  > = Omit<
    UseMutationOptions<Response["data"], Response["error"], Init>,
    "mutationKey" | "mutationFn"
  >,
> = ReturnType<typeof $api.useMutation<Method, Path, Init, Response, Options>>;
type InferSelectReturnType<TData, TSelect> = TSelect extends (
  data: TData,
) => infer R
  ? R
  : TData;
type ApiQueryShape<
  Method extends HttpMethod,
  Path extends PathsWithMethod<Paths, Method>,
  Init extends MaybeOptionalInit<Paths[Path], Method> = MaybeOptionalInit<
    Paths[Path],
    Method
  >,
  Response extends Required<
    FetchResponse<NonNullable<Paths[Path][Method]>, Init, Media>
  > = Required<FetchResponse<NonNullable<Paths[Path][Method]>, Init, Media>>,
  Options extends Omit<
    UseQueryOptions<
      Response["data"],
      Response["error"],
      InferSelectReturnType<Response["data"], Options["select"]>,
      QueryKey<any, Method, Path> //eslint-disable-line @typescript-eslint/no-explicit-any
    >,
    "queryKey" | "queryFn"
  > = Omit<
    UseQueryOptions<
      Response["data"],
      Response["error"],
      InferSelectReturnType<Response["data"], any>, //eslint-disable-line @typescript-eslint/no-explicit-any
      QueryKey<any, Method, Path> //eslint-disable-line @typescript-eslint/no-explicit-any
    >,
    "queryKey" | "queryFn"
  >,
> = ReturnType<typeof $api.useMutation<Method, Path, Init, Response, any>>; //eslint-disable-line @typescript-eslint/no-explicit-any

type ApiQueryData<
  Method extends HttpMethod,
  Path extends PathsWithMethod<Paths, Method>,
> = NonNullable<ApiQueryShape<Method, Path>["data"]>;
export { $api, fetchClient };
export type { ApiMutateShape, ApiQueryData, ApiQueryShape };

// <Method extends HttpMethod, Path extends PathsWithMethod<Paths, Method>, Init extends MaybeOptionalInit<Paths[Path], Method>, Response extends Required<FetchResponse<Paths[Path][Method], Init, Media>>, Options extends Omit<UseQueryOptions<Response["data"], Response["error"], InferSelectReturnType<Response["data"], Options["select"]>, QueryKey<Paths, Method, Path>>, "queryKey" | "queryFn">>
// <Method extends HttpMethod, Path extends PathsWithMethod<Paths, Method>, Init extends MaybeOptionalInit<Paths[Path], Method>, Response extends Required<FetchResponse<Paths[Path][Method], Init, Media>>, Options extends Omit<UseMutationOptions<Response["data"], Response["error"], Init>, "mutationKey" | "mutationFn">>
